import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';

import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { DataService } from 'src/app/shared/network/data.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ProjectService } from 'src/app/shared/project/project.service';
import { FormCompVarianceLine, FormulaItemType, RefVolumeBasis, RelativeImpactOptionsModel } from './reference-settings';
import { VarianceFormulaBaselineType } from './variance-formula-baseline';
import { ColumnScrollService } from '../../column-scroll.service';

import { ImportStep } from '../../import-step';

@Component({
    selector: 'relative-impact-options',
    templateUrl: './relative-impact-options.component.html',
    styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class RelativeImpactOptionsComponent extends BaseColumnSelectComponent implements OnInit {
    readonly step = ImportStep.RelativeImpactOptions;
    FormulaItemType: typeof FormulaItemType = FormulaItemType;
    VarianceFormulaBaselineType: typeof VarianceFormulaBaselineType = VarianceFormulaBaselineType;
    RefVolumeBasis: typeof RefVolumeBasis = RefVolumeBasis;
    public outcomeName: string;
    public basis: RefVolumeBasis;
    public oldControlValue: string;
    public newControlValue: string;
    public maxPerc: number;
    public oldBaseLine: FormCompVarianceLine[] | null;
    public newBaseLine: FormCompVarianceLine[] | null;
    public canonical: FormCompVarianceLine[] | null;

    loading = false;
    dataLoaded = false;

    constructor(private dataService: DataService, projectService: ProjectService, columnScrollService: ColumnScrollService) {
        super(projectService, columnScrollService);
    }

    public async loadDataInternal(): Promise<void> {
        const resp = await this.dataService.get<RelativeImpactOptionsModel>('columnSelection/relativeImpactOptions/' + this.projectId);
        this.stepState = resp.stepState;
        this.basis = resp.basis;
        this.maxPerc = resp.maxPerc;
        this.columns = resp.columns;
        this.outcomeName = resp.outcomeName;
        this.oldControlValue = resp.oldControlValue;
        this.newControlValue = resp.newControlValue;
        
        super.selectColumn(resp.columns.filter(c => c.isSelected)[0]);
        this.dataLoaded = true;
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    async save() {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            const changesApplied = await this.dataService.post<boolean>('columnSelection/relativeImpactOptions', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
                basis: this.basis,
                maxPerc: this.maxPerc,
            });
            this.finishStepSuccessfully(changesApplied);
        } finally {
            this.loading = false;
        }
    }

}
